import React from 'react';
import { CommonModalT } from './types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    capitalize,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export type GeneralModalButtonT = {
    text: string;
    onClick: () => void;
};

export type GeneralModalContainedButtonT = GeneralModalButtonT & {
    disabled?: boolean;
    tooltip?: string;
    className?: string;
};

export type GeneralModalProps = CommonModalT & {
    onClose: () => void;
    containedButton?: GeneralModalContainedButtonT;
    textButton?: GeneralModalButtonT;
    showCloseButton?: boolean;
};

const GeneralModal = ({
    isOpen,
    title,
    children,
    width = 'sm',
    onClose,
    containedButton = undefined,
    textButton = undefined,
    showCloseButton = true,
}: GeneralModalProps) => {
    return (
        <Dialog
            open={isOpen}
            fullScreen={width === 'full-screen'}
            fullWidth
            maxWidth={width === 'full-screen' ? false : width}
        >
            <DialogTitle>{title}</DialogTitle>{' '}
            {showCloseButton && (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.darkGrey,
                    })}
                >
                    <CloseIcon />
                </IconButton>
            )}
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                {textButton && (
                    <Button onClick={textButton.onClick} variant="text">
                        {capitalize(textButton.text)}
                    </Button>
                )}
                {containedButton && (
                    <Tooltip title={containedButton.tooltip}>
                        <span>
                            <Button
                                onClick={containedButton.onClick}
                                disabled={containedButton.disabled}
                                autoFocus
                                variant="contained"
                                className={containedButton.className}
                            >
                                {capitalize(containedButton.text)}
                            </Button>
                        </span>
                    </Tooltip>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default GeneralModal;
